import { render, staticRenderFns } from "./modal-advice-of-charge.vue?vue&type=template&id=856eb0f6&scoped=true"
import script from "./modal-advice-of-charge.vue?vue&type=script&lang=js"
export * from "./modal-advice-of-charge.vue?vue&type=script&lang=js"
import style0 from "./modal-advice-of-charge.vue?vue&type=style&index=0&id=856eb0f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "856eb0f6",
  null
  
)

export default component.exports